import { GetStaticProps } from 'next';
import React from 'react';
import { withGlobalProvider } from 'providers/globalProvider';
import { withTheme } from '@emotion/react';
import { getServerSidePropsTravelGuides } from '@layout/get-page-props';
import { storeWrapper } from '@state/store';
import { ContentApi } from '@model/iceberg';
import { PageTemplates } from '@model/content';
import { TripTypes } from '@model/common';
import {
  TravelGuidesListPageLayout,
  TravelGuidesListPageLayoutProps
} from '@layout/TravelGuidesListPageLayout/TravelGuidesListPageLayout';
import { DestinationLevel, getTravelGuidesStaticPaths } from '@util/get-destination-static-paths';

const TravelGuidesRegionPage = (props: TravelGuidesListPageLayoutProps) => {
  return <TravelGuidesListPageLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ req, params }: any) => {
  return await getServerSidePropsTravelGuides({ store, req, query: params, tripType: TripTypes.HOLIDAYS });
});

export async function getStaticPaths() {
  const pageConfigMap = await new ContentApi().getPageConfigMap({ template: PageTemplates.LIST_PAGE });
  const paths = getTravelGuidesStaticPaths(pageConfigMap, DestinationLevel.REGION, TripTypes.HOLIDAYS);

  return { paths, fallback: false };
}

export default withGlobalProvider(withTheme(TravelGuidesRegionPage));
